import { StatusCode } from "api/protocols";
import { GetEmailCampaigns } from "api/rpc/2024-04/facilityAdmin/marketing/emailCampaigns";
import type { IEmailCampaignDesignStatus } from "api/rpc/2024-04/facilityAdmin/marketing/emailBuilderTypes";

export async function getEmailCampaignDesignStatus(
  campaignId: number,
  useGlobalLoader: boolean = false,
): Promise<{
  status: number;
  data: IEmailCampaignDesignStatus | null;
  message: string;
}> {
  const resp = await GetEmailCampaigns({ id: campaignId }, useGlobalLoader);
  if (resp.status !== StatusCode.OK || !Array.isArray(resp.data) || resp.data.length === 0) {
    return {
      status: resp.status,
      data: null,
      message:
        typeof resp.message === "string" && resp.message.length > 0
          ? resp.message
          : "Could not load email campaign design status.",
    };
  }

  return {
    status: StatusCode.OK,
    data: resp.data[0].design ?? null,
    message: "",
  };
}
